import React, { useEffect } from "react";
import MainLayout from "../component/shared/layout/MainLayout";
import LadyComponent from "../component/shared/LadyComponent/LadyComponent";
import CertifiedComponent from "../component/shared/Certified/CertifiedComponent";
import FreeQuoteToday from "../component/shared/FreeQuote/FreeQuoteToday";
import ServicesPageTopComponent from "../component/shared/ServicesPageTopComponent/ServicesPageTopComponent";
import PageTitle from "../component/shared/PageTitle/PageTitle";
import ServicesInfo from "../component/shared/ServicesInfo/ServicesInfo";
import SharedOurValueComponent from "../component/shared/SharedOurValueComponent/SharedOurValueComponent";
import ButtonContact from "../component/shared/ButtonContact/ButtonContact";
import {
  service_fiber,
  servies_info,
  title,
  values,
} from "../Services/ServicesFiberGlass";
import MadeFrom from "../component/shared/MadeFrom/MadeFrom";
import { headerinfo, madeFromServicesDetail } from "../Services/ServicesDetail";
import { useLocation } from "react-router-dom";

function ServicesFiberGlass() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <MainLayout>
        <ServicesPageTopComponent pageData={service_fiber} />
        <PageTitle title={title} />
        <ServicesInfo first={servies_info} />
        <SharedOurValueComponent values={values} />
        <ButtonContact />
        <MadeFrom madefrom={madeFromServicesDetail} title={headerinfo} />
        <LadyComponent />
        <CertifiedComponent />
        <FreeQuoteToday />
      </MainLayout>
    </div>
  );
}

export default ServicesFiberGlass;
